import { render, staticRenderFns } from "./department-selector.vue?vue&type=template&id=418f4c66"
import script from "./department-selector.vue?vue&type=script&lang=ts"
export * from "./department-selector.vue?vue&type=script&lang=ts"
import style0 from "./department-selector.vue?vue&type=style&index=0&id=418f4c66&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('418f4c66')) {
      api.createRecord('418f4c66', component.options)
    } else {
      api.reload('418f4c66', component.options)
    }
    module.hot.accept("./department-selector.vue?vue&type=template&id=418f4c66", function () {
      api.rerender('418f4c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/department-selector/department-selector.vue"
export default component.exports